import React from "react";
import Context from "../assets/js/Context.js";
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FcApproval } from "react-icons/fc";

class Orders extends React.Component {
    constructor() {
        super();
        this.displayDataAdt = [];
        this.displayDataAdt2 = [];
        this.state = {
        };

    }
    render() {

        return (
            <div>
                <Context.Consumer>
                    {ctx => {
                        return (
                            <div style={{ height: '100vh', width: '100%', display: 'flex',flexDirection:'column', alignItems: 'center', justifyContent: 'center' }}>
                                    <FcApproval style={{ fontSize: 60 }} />
                            
                                <div style={{ display: 'flex' ,margin:20}}>
                                    <h4>تم ارسال الطلب بنجاح</h4>


                                </div>
                                <div style={{  display: 'flex', }}>
                                    <Link to='/FromUser'>
                                        <Button variant="primary" style={{width:100,margin:10,fontWeight:'bold'}}>
                                            طلب جديد
                                        </Button>
                                    </Link>
                                    <Link to='/'>
                                        <Button variant="primary" style={{width:100,margin:10,fontWeight:'bold'}}>
                                            الرئيسيه
                                        </Button>
                                    </Link>

                                </div>
                            </div>
                        )


                    }}
                    
                </Context.Consumer>
            </div>
        );
    }
}

export default Orders;